import * as Components from './components';
import {classify} from '@resman/utils/classify';

export const GlobalVueComponents = {};

export const ResManComponentTracker = {
  install(Vue) {
    if (Vue.$_vuetify_installed) {
      throw new Error(`You must install "ResManComponentTracker" BEFORE Vuetify`);
    }
    if (Vue.$_resman_preload_installed) return;
    Vue.$_resman_preload_installed = true;

    // Monkey patching Vue.component to keep track of global components
    const original = Vue.component.bind(Vue);
    Vue.component = function(componentName, component) {
      GlobalVueComponents[componentName] = component;

      return original(componentName, component);
    };
  },
};

export const ResManUIPlugin = {
  install(Vue, options = {}) {
    Object.keys(Components).forEach((key) => {
      Vue.component(key, Components[key]);
    });

    const {componentDefaults} = options.theme || {};
    if (!componentDefaults) return;

    if (!Vue.$_vuetify_installed) {
      throw new Error(`You must install "ResManUIPlugin" after Vuetify`);
    }
    if (!Vue.$_resman_preload_installed) {
      throw new Error(`You must install "ResManComponentTracker" before all other plugins`);
    }

    Object.keys(componentDefaults).forEach((componentName) => {
      // This will convert v-text-field to VTextField TODO: Test this
      componentName = classify(componentName);

      const component = GlobalVueComponents[componentName];
      if (!component) {
        console.warn(`Component Defaults: Component ${componentName} not found`);

        return;
      }

      const {props} = component.options;
      const defaults = componentDefaults[componentName];
      Object.keys(defaults).forEach((propName) => {
        const prop = props[propName];
        if (!prop) {
          console.warn(`Component Defaults: Prop ${propName} not found on component ${componentName}`);

          return;
        }

        // XXX - It appears that the prop object for multiple components are a shared object, so creating a new object
        // to prevent altering other components
        props[propName] = {
          ...prop,
          default: defaults[propName],
        };
      });
    });
  },
}


export function buildVuetifyOptionsFromTheme({theme}) {
  const vuetifyOptions = {
    theme: {
      options: {
        customProperties: true,
      },
      themes: {},
    },
  };

  if (theme) {
    const {vuetifyTheme} = theme;
    if (vuetifyTheme) {
      // Allow the theme to skip specifying the light/dark variation
      if (vuetifyTheme.light || vuetifyTheme.dark) {
        vuetifyOptions.theme.themes = vuetifyTheme;
      }
      else {
        vuetifyOptions.theme.themes.light = vuetifyTheme;
      }
    }
  }

  return vuetifyOptions;
}
